import { UseActiveUser } from '../../../store/user.store'
import { responseError } from '../../../utilitários/handler/responseHandler'
import { LocalStorage } from '../../../utilitários/localStorage/LocalStorage'

import { AutenticacaoModel } from '@/@types/Models'
import { api } from '@/api/api'
import { rotasApi } from '@/configurações/rotasApi'
import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const useMe = () => {
  const { setUserActive } = UseActiveUser()
  const storage = new LocalStorage()
  const {
    data: dataMe,
    error: errorMe,
    status: statusMe,
    isLoading: isLoadingMe,
  } = useQuery<AutenticacaoModel, AxiosError<any>>({
    queryKey: ['me'],
    queryFn: endPoint,
    onSuccess: (data) => {
      setUserActive(data)
    },
  })

  return { dataMe, errorMe, statusMe, isLoadingMe }
}

async function endPoint(): Promise<AutenticacaoModel> {
  const result = await api().get(rotasApi.me)
  return result.data.data
}
